import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

const account = Vue.prototype.$account
const ui = Vue.prototype.$ui
const clicky = Vue.prototype.$services.clicky

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(to => {
  // rg4js('trackEvent', { type: 'pageView', path: to.path }); // eslint-disable-line
  if (process.env.VUE_APP_ENV === 'production' || true) {
    clicky.logBrowse(to.path)
  }
})

// Handle the account tasks before routing
router.beforeEach(account.routerBeforeEach)
router.beforeEach(ui.routerBeforeEach)

// Handling middlewares
router.beforeEach((to, from, next) => {
  if (to.meta.middlewares && to.meta.middlewares.length) {
    to.meta.middlewares.forEach(middleware => {
      middleware(to, from, next)
    })
  } else {
    next()
  }
})

export default router
